import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {Button, Form, Spinner} from "react-bootstrap";
import {useSelector} from "react-redux";


const AddJobPriority = () => {

    let navigate = useNavigate();

    const [client, setClient] = useState()
    const [address, setAddress] = useState()

    const [priority_date, set_priority_date] = useState('')
    const [priority, set_priority] = useState('DEFAULT')
    const [finished, set_finished] = useState('DEFAULT')

    const [doneSubmitting, setDoneSubmitting] = useState(false)

    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin


    const { id } = useParams();

    const loadClient = async () => {
        const { data } = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/clients/${id}/`, {
        // const { data } = await axios.get(`http://127.0.0.1:8000/api/clients/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        })
        setClient(data.id)
        setAddress(data.work_site_address)
    }

    useEffect(() => {
        loadClient()
    }, []);

    let redirect = ''
    if (userInfo){
        if (userInfo.group === "AdminSuper"){
            redirect = `/search_results/${id}/`
        } else if (userInfo.group === "Finance") {
            redirect = '/finance_active_work_orders'
        } else if (userInfo.group === "Logistics") {
            redirect = '/logistics_dash'
        } else if (userInfo.group === "Tech") {
            redirect = `/search_results/${id}/`
        }
    }

    const AddPriority = async () => {
        if (priority_date===''){
            alert("Add Priority Date")
        } else if (priority==='DEFAULT'){
            alert("Add Priority Setting")
        } else if (finished==='DEFAULT'){
            alert("Add if Finished")
        } else {
            setDoneSubmitting(true)
            let formField = new FormData()
            formField.append('client', client)
            formField.append('priority_date', priority_date)
            formField.append('priority', priority)
            formField.append('finished', finished)

            // console.log(formField)
            await axios ({
                method: 'post',
                url: `https://homesafetysolutions.pythonanywhere.com/api/clients/${client}/add_priority/`,
                // url: `http://127.0.0.1:8000/api/clients/${client}/add_priority/`,
                headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${userInfo.token}`
                    },
                data: formField,
            }).then(() => {
                navigate(redirect)
            })
            setDoneSubmitting(false)
        }
    }

    return(
        <div>
            <h1>Create Priority for: {address}</h1>

            <Form>

                <Form.Group controlId={'priority_date'}>
                    <Form.Label>Priority Date:</Form.Label>
                    <Form.Control
                        type={'date'}
                        placeholder={"priority_date"}
                        value={priority_date}
                        onChange={(e) => set_priority_date(e.target.value)}
                    />
                </Form.Group>

                <Form.Group controlId={'priority'}>
                    <Form.Label>Priority:</Form.Label>
                    <Form.Select
                        defaultValue={'DEFAULT'}
                        onChange={(e) => set_priority(e.target.value)}
                    >
                        <option value={'DEFAULT'}>Set Priority</option>
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                        <option value="High">High</option>
                    </Form.Select>
                </Form.Group>

                <Form.Group controlId={'finished'}>
                    <Form.Label>Finished:</Form.Label>
                    <Form.Select
                        defaultValue={'DEFAULT'}
                        onChange={(e) => set_finished(e.target.value)}
                    >
                        <option value={'DEFAULT'}>Set Is Job Finished</option>
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </Form.Select>
                </Form.Group>

                <br/>
                {
                    doneSubmitting
                        ?
                        (
                            <span>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                Loading...
                            </span>
                        )
                        :
                        (
                            <Button className={'btn btn-success'} onClick={AddPriority}>Add Priority</Button>
                        )
                }
            </Form>

        </div>
    );

};


export default AddJobPriority

